import svgToMiniDataURI from 'mini-svg-data-uri';

function svguri(strings) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  return function (props) {
    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var nextStr = strings[i + 1];

      if (typeof key === 'function') {
        result.push(key(props), nextStr);
      } else {
        result.push(key, nextStr);
      }
    });
    return svgToMiniDataURI(result.join(''));
  };
}

export default svguri;
//# sourceMappingURL=svguri.js.map